import { useState } from 'react';
import { Modal } from '@zopauk/react-components';
import { Carousel } from 'react-responsive-carousel';
import { MembersQuery } from '@/utils/api/dato/generated';

type MembersProps = {
  members: MembersQuery | undefined;
};

const Members = ({ members }: MembersProps) => {
  const [isOpen, update] = useState(false);
  const [selected, setSelected] = useState(0);
  const handleClick = (index: number) => {
    setSelected(index);
    return toggleModal();
  };

  const toggleModal = () => update((prevState) => !prevState);
  return (
    <>
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl lg:text-6xl font-serif text-primary mb-8 text-center">Our Members</h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 lg:grid-cols-3 gap-8">
          {members?.allMembersModels?.map((member, id) => (
            <div
              className="bg-background rounded-xl shadow-sm hover:shadow-xl transition p-6 flex flex-col
                        items-center text-center cursor-pointer"
              onClick={() => handleClick(id)}
              key={`${id}-member`}
            >
              <img
                className="h-20 w-auto object-contain mb-6"
                src={member.logo?.url || ''}
                alt={member.logo?.alt || ''}
              />

              <p className="text-lg font-semibold text-gray-800">{member.name}</p>
            </div>
          ))}
        </div>
      </div>
      <Modal onRequestClose={toggleModal} isOpen={isOpen}>
        <div className="block relative z-2 max-w-[506px]">
          <Carousel
            renderArrowNext={(clickHandler: () => void) => (
              <div
                onClick={() => {
                  const total = members?.allMembersModels?.length ?? 0;
                  if (total === 0) {
                    return;
                  }

                  setSelected((prev) => (prev === total - 1 ? 0 : prev + 1));

                  return clickHandler();
                }}
                className="absolute z-30 bottom-5 bg-gray-100 m-2 p-1 pt-2 rounded hover:bg-base-200 transition right-4 cursor-pointer"
              >
                <span className="material-symbols-outlined">chevron_right</span>
              </div>
            )}
            renderArrowPrev={(clickHandler: () => void) => (
              <div
                onClick={() => {
                  const total = members?.allMembersModels?.length ?? 0;
                  if (total === 0) {
                    return;
                  }

                  setSelected((prev) => (prev > 0 ? prev - 1 : total - 1));

                  return clickHandler();
                }}
                className="absolute z-30 bottom-5 bg-gray-100 m-2 p-1 pt-2 rounded hover:bg-base-200 transition left-4 cursor-pointer"
              >
                <span className="material-symbols-outlined">chevron_left</span>
              </div>
            )}
            useKeyboardArrows={true}
            animationHandler="fade"
            selectedItem={selected}
            showIndicators={false}
            ariaLabel="carousel"
            infiniteLoop={false}
            showStatus={false}
            showThumbs={false}
            showArrows={true}
            swipeable={false}
          >
            {members?.allMembersModels?.map((member, id) => (
              <div className="px-9 py-5 pb-4 rounded-xl max-w-[506px]" key={`${id}-slide`}>
                <div className="py-4 lg:py-5 pl-2 lg:pb-6 flex items-left">
                  <img alt={member.logo?.alt || ''} src={member.logo?.url} className="w-20" />
                </div>

                <div className="flex items-center mb-6">
                  <div className="flex-shrink-0 w-12 h-12">
                    <img
                      alt={member.representativeImage?.alt || ''}
                      src={member.representativeImage?.url}
                      className="rounded-full object-cover"
                    />
                  </div>

                  <div className="pl-4 flex-1">
                    <p className="font-bold text-left">
                      {member.representativeName}, {member.representativeTitle}
                    </p>
                  </div>
                </div>
                <div className="text-left sm:pr-5 w-full">
                  <p>{member.representativeQuote}</p>
                </div>

                <div className="h-[85px] mt-4"></div>
                <div className="absolute h-[85px] mt-4 bottom-0 bg-base-100 left-0 w-full"></div>
              </div>
            ))}
          </Carousel>
        </div>
      </Modal>
    </>
  );
};

export default Members;
